"use strict";

exports.__esModule = true;
exports.default = exports.enhance = exports.PieLayoutDefaultProps = void 0;

var _react = require("react");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _d3Shape = require("d3-shape");

var _setDisplayName = _interopRequireDefault(require("recompose/setDisplayName"));

var _compose = _interopRequireDefault(require("recompose/compose"));

var _pure = _interopRequireDefault(require("recompose/pure"));

var _defaultProps = _interopRequireDefault(require("recompose/defaultProps"));

var _withPropsOnChange = _interopRequireDefault(require("recompose/withPropsOnChange"));

var _core = require("@nivo/core");

var _colors = require("@nivo/colors");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

class PieLayout extends _react.Component {
  render() {
    const _this$props = this.props,
          arcs = _this$props.arcs,
          arcGenerator = _this$props.arcGenerator,
          startAngle = _this$props.startAngle,
          endAngle = _this$props.endAngle,
          width = _this$props.width,
          height = _this$props.height,
          centerX = _this$props.centerX,
          centerY = _this$props.centerY,
          radius = _this$props.radius,
          innerRadius = _this$props.innerRadius,
          debug = _this$props.debug,
          render = _this$props.children;
    return render({
      arcs,
      arcGenerator,
      startAngle,
      endAngle,
      width,
      height,
      centerX,
      centerY,
      radius,
      innerRadius,
      debug
    });
  }

}

PieLayout.propTypes = process.env.NODE_ENV !== "production" ? {
  data: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.string.isRequired,
    value: _propTypes.default.number.isRequired
  })).isRequired,
  width: _propTypes.default.number.isRequired,
  height: _propTypes.default.number.isRequired,
  fit: _propTypes.default.bool.isRequired,
  sortByValue: _propTypes.default.bool.isRequired,
  startAngle: _propTypes.default.number.isRequired,
  endAngle: _propTypes.default.number.isRequired,
  padAngle: _propTypes.default.number.isRequired,
  arcs: _propTypes.default.array.isRequired,
  // computed
  arcGenerator: _propTypes.default.func.isRequired,
  // computed
  centerX: _propTypes.default.number.isRequired,
  // computed
  centerY: _propTypes.default.number.isRequired,
  // computed
  radius: _propTypes.default.number.isRequired,
  // computed
  innerRadius: _propTypes.default.number.isRequired,
  // re-computed
  cornerRadius: _propTypes.default.number.isRequired,
  debug: _propTypes.default.shape({
    points: _propTypes.default.array.isRequired,
    box: _propTypes.default.shape({
      x: _propTypes.default.number.isRequired,
      y: _propTypes.default.number.isRequired,
      width: _propTypes.default.number.isRequired,
      height: _propTypes.default.number.isRequired
    }).isRequired,
    ratio: _propTypes.default.number.isRequired
  }),
  // computed
  children: _propTypes.default.func.isRequired
} : {};
const PieLayoutDefaultProps = {
  fit: true,
  sortByValue: false,
  innerRadius: 0,
  startAngle: 0,
  endAngle: 360,
  padAngle: 0,
  cornerRadius: 0
};
exports.PieLayoutDefaultProps = PieLayoutDefaultProps;

const enhance = Component => (0, _compose.default)((0, _defaultProps.default)(PieLayoutDefaultProps), (0, _withPropsOnChange.default)(['colors'], ({
  colors
}) => ({
  getColor: (0, _colors.getOrdinalColorScale)(colors, 'id')
})), (0, _withPropsOnChange.default)(['width', 'height', 'innerRadius', 'startAngle', 'endAngle', 'fit', 'cornerRadius'], ({
  width,
  height,
  innerRadius: _innerRadius,
  startAngle,
  endAngle,
  fit,
  cornerRadius
}) => {
  let radius = Math.min(width, height) / 2;
  let innerRadius = radius * Math.min(_innerRadius, 1);
  let centerX = width / 2;
  let centerY = height / 2;
  let boundingBox;

  if (fit === true) {
    const _computeArcBoundingBo = (0, _core.computeArcBoundingBox)(centerX, centerY, radius, startAngle - 90, endAngle - 90),
          points = _computeArcBoundingBo.points,
          box = _objectWithoutPropertiesLoose(_computeArcBoundingBo, ["points"]);

    const ratio = Math.min(width / box.width, height / box.height);
    const adjustedBox = {
      width: box.width * ratio,
      height: box.height * ratio
    };
    adjustedBox.x = (width - adjustedBox.width) / 2;
    adjustedBox.y = (height - adjustedBox.height) / 2;
    centerX = (centerX - box.x) / box.width * box.width * ratio + adjustedBox.x;
    centerY = (centerY - box.y) / box.height * box.height * ratio + adjustedBox.y;
    boundingBox = {
      box,
      ratio,
      points
    };
    radius = radius * ratio;
    innerRadius = innerRadius * ratio;
  }

  const arcGenerator = (0, _d3Shape.arc)().outerRadius(radius).innerRadius(innerRadius).cornerRadius(cornerRadius);
  return {
    centerX,
    centerY,
    radius,
    innerRadius,
    arcGenerator,
    debug: boundingBox
  };
}), (0, _withPropsOnChange.default)(['sortByValue', 'padAngle', 'startAngle', 'endAngle'], ({
  sortByValue,
  padAngle,
  startAngle,
  endAngle
}) => {
  const pie = (0, _d3Shape.pie)().value(d => d.value).padAngle((0, _core.degreesToRadians)(padAngle)).startAngle((0, _core.degreesToRadians)(startAngle)).endAngle((0, _core.degreesToRadians)(endAngle));
  if (sortByValue !== true) pie.sortValues(null);
  return {
    pie
  };
}), (0, _withPropsOnChange.default)(['pie', 'data'], ({
  pie,
  data
}) => ({
  arcs: pie(data).map(arc => {
    const angle = Math.abs(arc.endAngle - arc.startAngle);
    return _extends({}, arc, {
      angle,
      angleDeg: (0, _core.radiansToDegrees)(angle)
    });
  })
})), (0, _withPropsOnChange.default)(['arcs', 'getColor'], ({
  arcs,
  getColor
}) => ({
  arcs: arcs.map(arc => _extends({}, arc, {
    color: getColor(arc.data)
  }))
})), _pure.default)(Component);

exports.enhance = enhance;

var _default = (0, _setDisplayName.default)('PieLayout')(enhance(PieLayout));

exports.default = _default;